import { gsap, Power1, Power3 } from 'gsap'

export default class Loadizi {
    constructor(el) {
        // Check element
        if(el instanceof HTMLElement) {
            this.el = el
        } else {
            this.el = document.querySelector(el)
        }
        if(!this.el) {
            console.warn('No valid loader found. Sorry bro.')
            return false
        }
        this.firstBackground = this.el.querySelector('.o-body_loaderBackground.-first')
        this.secondBackground = this.el.querySelector('.o-body_loaderBackground.-second')
        this.images = this.el.querySelector('.o-body_loaderImages')
        this.fill = this.el.querySelector('.o-body_loaderFill')
    }

    show(resolve) {
        // Reinit
        gsap.set(this.el, { opacity: 0 })
        gsap.set(this.images, { opacity: 1 })
        gsap.set(this.firstBackground, { y: 0 })
        gsap.set(this.secondBackground, { y: 0 })
        this.el.style.display = 'block'
        // Set progress to 0
        gsap.set(this.fill, { 'clip-path': 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)' })
        // Fade in
        gsap.to(this.el, {
            opacity: 1,
            duration: 0.5,
            onComplete: resolve
        })
    }
    hide(resolve) {
        resolve()
        // Fade out
        gsap.to(this.images, {
            opacity: 0,
            duration: 0.75
        })
        gsap.to(this.firstBackground, {
            y: '-100%',
            duration: 1.3,
            ease: Power3.easeInOut
        })
        gsap.to(this.secondBackground, {
            y: '-100%',
            duration: 1.5,
            ease: Power3.easeInOut,
            onComplete: () => {
                this.el.style.display = 'none'
            }
        })
    }
    progress(value, duration = 0.5, resolve) {
        gsap.to(this.fill, {
            'clip-path': `polygon(0% ${100 - value}%, 100% ${100 - value}%, 100% 100%, 0% 100%)`,
            duration: duration,
            ease: Power1.easeInOut,
            onComplete: resolve
        })
    }
}